/**
 * Given a <text> node in an SVG element it will resize the text inside to fit
 * within the SVG element no matter what the size of the SVG is.
 *
 * @param {SVGTextElement} textNode The text node to resize
 */
export default function fitSvgTextNode(textNode) {
    var svgElement = textNode.closest("svg");
    var bb = textNode.getBBox();
    // dynamically adjust "padding" based on textNode width
    var dynamicPadding = 3;
    if (bb.width < 90) {
        dynamicPadding = 2;
    }
    if (bb.width < 80) {
        dynamicPadding = 1;
    }
    if (bb.width < 75) {
        dynamicPadding = 0;
    }
    // The rationale for using animVal in below is that it will be the
    // the same as baseVal under most circumstances, but on the off
    // chance that animation is applied and running it will represent
    // the current value of the attribute instead of the value at some
    // point in the past.
    var widthTransform = (svgElement.width.animVal.value - dynamicPadding) / bb.width;
    var heightTransform = (svgElement.height.animVal.value - dynamicPadding) / bb.height;
    var transformValue = widthTransform < heightTransform ? widthTransform : heightTransform;
    // Scale to fit within it's parent SVG element
    textNode.setAttribute("transform", "matrix(".concat(transformValue, ", 0, 0, ").concat(transformValue, ", 0,0)"));
    // Default transform does top left as the origin. We want the origin
    // instead to be the center or else it won't be placed in the middle
    textNode.setAttribute("transform-origin", "50% 50%");
}
